// @flow

/**
 * Module dependencies.
 */

import { chain, head } from 'lodash';
import { colors } from 'client/styles';
import { translator } from 'core/utils';
import ContactForm from 'client/components/contacts/contact-form';
import Content from 'client/components/content';
import GeneralContacts from 'client/components/contacts/general-contacts';
import Header from 'client/components/header';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import entities from 'client/core/entities';
import formSubmitWrapper from 'client/components/forms/components/form-submit-wrapper';
import zendeskEntities from 'client/core/entities/zendesk';

/**
 * `ContactFormSubmit` component.
 */

const ContactFormSubmit = formSubmitWrapper(ContactForm);

/**
 * `Props` type.
 */

type Props = {
  location: Object,
  translate: Function
};

/**
 * Export `Contacts`.
 */

class Contacts extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { location, translate } = this.props;
    const { mailSubjects, reasons } = zendeskEntities(translate);
    const { contacts } = entities(translate);
    const hash = location.hash.replace('#', '');

    const defaultReason = chain(reasons)
      .filter(({ value }: Object): boolean => value === hash)
      .head()
      .get('value', head(reasons).value)
      .value();

    const labels = {
      address: translate('contacts.general.address'),
      europePhone: translate('contacts.general.europePhone'),
      link: translate('contacts.general.link'),
      phone: translate('contacts.general.phone')
    };

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'contacts-header'}
          lead={translate('contacts.lead')}
          title={translate('contacts.title')}
        />

        <Content
          pullTop
          separator
        >
          <ContactFormSubmit
            selectOptions={reasons}
            selectedOption={defaultReason}
            subject={mailSubjects.contact}
            subjectField={'reason'}
          />

          <GeneralContacts
            contacts={contacts}
            labels={labels}
          />
        </Content>
      </PageContent>
    );
  }

}

/**
 * Export `Contacts` component.
 */

export default translator()(Contacts);



// WEBPACK FOOTER //
// ../src/client/containers/contacts/index.js